<template lang="pug">
  v-container(fluid)
    v-row.px-2.px-sm-10.pb-10
      v-col(cols="12")
        h1 {{ translations.title }}

    v-row.px-2.px-sm-10.pb-10(align="center" justify="center")
      //- filtros
      v-col(cols="12" lg="4" md="6" sm="12")
        v-text-field(v-model="namefilter"  :label="translations.filter.name" clearable)
      v-col(cols="12" lg="4" md="6" sm="12")
        v-menu(v-model="dateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px")
          template(v-slot:activator="{ on }")
            v-text-field(:label="translations.filter.startDate" prepend-inner-icon="mdi-calendar" readonly slot="activator" v-on="on" v-model="dateStart" @click:clear="dateStart = null" clearable)
          v-date-picker(v-model="dateStart" @input="dateMenu = false")
      v-col(cols="12" lg="4" md="6" sm="12")
        v-select(v-model="statusFilter"  :items="status" item-text="text" item-value="value" return-object :label="translations.filter.status" clearable)

      //- vista como table
      v-col(cols="12").text-right
          v-btn(color="primary" @click="updateContest" text)
              v-icon mdi-reload
      v-col(cols="12")
        //- :custom-sort="customSort"
        v-data-table(
          :headers="headers"
          :items="datos" 
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
          )
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items"  :key="'item'+item._id")
                td {{ item.name }}
                td
                  span.fantasy__block-width--8 {{ item.startdate }}
                td {{ item.status.text }}
                td {{ item.sport }}
                td
                  v-menu(v-if="hasPermission('views.fantasy.contests.actionsContest')" offset-y)
                    template(v-slot:activator="{ on }")
                      v-btn(:color="getColorStatus(item.status.value)" text v-on="on")
                        v-icon mdi-cog-outline
                    v-list.fantasy-contest__list
                      v-list-item(v-if="item.status.value === 'pending' || item.status.value === 'new'")
                        v-list-item-title.text-center
                          BaseConfirmDialog(@confirm="executeContestAction(item._id,'open')" v-bind="translations.confirmationDialog.actions")
                            template(v-slot="{ on }")
                              v-btn(v-on="on" text).green--text {{ translations.actions.open }}
                      v-list-item(v-if="item.status.value === 'open' || item.status.value === 'new'")
                        v-list-item-title.text-center
                          BaseConfirmDialog(@confirm="executeContestAction(item._id,'abandom')" v-bind="translations.confirmationDialog.actions")
                            template(v-slot="{ on }")
                              v-btn(v-on="on" text).red--text {{ translations.actions.abandom }}
                      v-list-item(v-if="item.status.value === 'open'")
                        v-list-item-title.text-center
                          BaseConfirmDialog(@confirm="executeContestAction(item._id,'close')" v-bind="translations.confirmationDialog.actions")
                            template(v-slot="{ on }")
                              v-btn(v-on="on" text).red--text {{ translations.actions.close }}
                      v-list-item(v-if="item.status.value === 'closed' || item.status.value === 'finish'")
                        v-list-item-title.text-center
                          BaseConfirmDialog(@confirm="executeContestAction(item._id,'finish')" v-bind="translations.confirmationDialog.actions")
                            template(v-slot="{ on }")
                              v-btn(v-on="on" text).blue--text {{ translations.actions.finish }}
                      v-list-item(v-if="item.status.value === 'closed' || item.status.value === 'finish'")
                        v-list-item-title.text-center
                          BaseConfirmDialog(@confirm="executeContestAction(item._id,'score')" v-bind="translations.confirmationDialog.actions")
                            template(v-slot="{ on }")
                              v-btn(v-on="on" text).pink--text {{ translations.actions.score }}
                      v-list-item(v-if="item.status.value === 'closed'")
                        v-list-item-title.text-center
                          BaseConfirmDialog(@confirm="executeContestAction(item._id,'suspen')" v-bind="translations.confirmationDialog.actions")
                            template(v-slot="{ on }")
                              v-btn(v-on="on" text).pink--text {{ translations.actions.suspen }}
                      v-list-item(v-if="item.status.value === 'finished'")
                        v-list-item-title.text-center
                          BaseConfirmDialog(@confirm="executeContestAction(item._id,'winners')" v-bind="translations.confirmationDialog.actions")
                            template(v-slot="{ on }")
                              v-btn(v-on="on" text).orange--text {{ translations.actions.winners }}
                      v-list-item(v-if="item.status.value === 'finished'")
                        v-list-item-title.text-center
                          BaseConfirmDialog(@confirm="executeContestAction(item._id,'score')" v-bind="translations.confirmationDialog.actions")
                            template(v-slot="{ on }")
                              v-btn(v-on="on" text).pink--text {{ translations.actions.score }}
                  v-chip(v-else :color="getColorStatus(item.status.value)" label) 
                    v-icon mdi-cog-outline
                //- td      //TODO, Pendiente, ocultar hasta tener definida la información que mostrar
                //-   v-btn(@click="viewContest(item._id)" text color="primary") Ver info
                td(v-if="hasPermission('views.fantasy.contests.editContest')")
                  BaseDialog(type="edit", :title="translationsForm.title.edit  + item.name" v-slot="{close, opened}")
                    ContestEdit(@successEdit="updateContest(opened,close)", :clearForm="opened", :contest="item", :translations="translationsForm")
          template(v-slot:footer)
            .d-flex.justify-space-between.flex-wrap.pa-2
              span.mr-2.mb-2
                v-btn.mr-2(:color="getColorStatus('pending')" readonly text)
                  v-icon mdi-cog-outline
                span {{ $t('back.status.pending') }}
              span.mr-2.mb-2
                v-btn.mr-2(:color="getColorStatus('new')" readonly text)
                  v-icon mdi-cog-outline
                span {{ $t('back.status.new') }}
              span.mr-2.mb-2
                v-btn.mr-2(:color="getColorStatus('open')"  readonly text)
                  v-icon mdi-cog-outline
                span {{ $t('back.status.open') }}
              span.mr-2.mb-2
                v-btn.mr-2(:color="getColorStatus('closed')" readonly text)
                  v-icon mdi-cog-outline
                span {{ $t('back.status.closed') }}
              span.mr-2.mb-2
                v-btn.mr-2(:color="getColorStatus('finished')" readonly text)
                  v-icon mdi-cog-outline
                span {{ $t('back.status.finished') }}
      BaseDialog(v-if="hasPermission('views.administrators.createAdministrator')" type="create", :title="translationsForm.title.create" v-slot="{close, opened}")
        ContestCreate(@successCreate="updateContest(opened,close)", :clearForm="opened", :translations="translationsForm", :poolType="poolType", :payout="payout", :championshipFormat="championshipFormat")
</template>

<script>

  import ContestCreate from '@/components/forms/ContestCreate';
  import ContestEdit from '@/components/forms/ContestEdit';
  import { payout, poolType, championshipFormat } from "@/store/variablesGlobals";

  export default {
    name: 'FantasyContestsIndex',
    components: {
      ContestCreate,
      ContestEdit,
    },
    data: () => ({
      poolType: poolType,
      payout: payout,
      championshipFormat: championshipFormat,
      tab:null,
      dateMenu: false,
      dateStart: null,
      statusFilter: {
        text: '',
        value: ''
      },
      namefilter: '',
    }),
    computed: {
      translations() {
        return this.$t("views.contestsIndex");
      },
      translationsForm() {
        return this.$t("forms.contest");
      },
      headers(){
        let headers = [
          {
            text: this.translations.tableHeadText.name,
            value: 'name'
          },
          {
            text: this.translations.tableHeadText.startDate,
            value: 'startdate'
          },
          {
            text: this.translations.tableHeadText.status,
            value: 'status'
          },
          {
            text: this.translations.tableHeadText.sport,
            value: 'sport'
          },
          {
            text: this.translations.tableHeadText.options,
            value: 'options',
            sortable: false
          },
          // {      //TODO, Pendiente, ocultar hasta tener definida la información que mostrar
          //   text: '',
          //   value: 'stats',
          //   sortable: false
          // },
        ];
        if(this.hasPermission('views.fantasy.contests.editContest')){
          headers.push(
            {
              text: '',
              value: 'edit',
              sortable: false
            });
        }
        return headers;
      },
      datos(){
        const vm = this;
        return this.contestsFiltered.map(contest =>{
          return {
            _id: contest._id,
            name: contest.name,
            startdate: vm.$moment(contest.cfg.start).format('DD/MM/YYYY HH:mm'),
            enddate: vm.$moment(contest.cfg.end).format('DD/MM/YYYY HH:mm'),
            status: {
              text: contest.status != ''? vm.$t('back.status.'+ contest.status) : '',
              value: contest.status
            },
            sport: contest.sport == '' || contest.sport == undefined ? '' : vm.$t('back.sport.'+ contest.sport),
          }
        })
      },
      status(){
        return [
          {
            text: this.$t('back.status.pending'),
            value: 'pending'
          },
          {
            text: this.$t('back.status.open'),
            value: 'open'
          },
          {
            text: this.$t('back.status.closed'),
            value: 'closed'
          },
          {
            text: this.$t('back.status.finished'),
            value: 'finished'
          }
        ];
      },
      contestsListAll() {
        return this.$store.state.fantasy.contests;
      },
      contestsFiltered(){
        const vm = this;

        const filters = {
          name: {
            function: vm.filterName,
            condition: vm.namefilter
          },
          startDate: {
            function: vm.filterStartDate,
            condition: vm.dateStart
          },
          status: {
            function: vm.filterStatus,
            condition: vm.statusFilter
          }
        };

        return this.contestsListAll.filter(player => {
          const filterKeys = Object.keys(filters);
          return filterKeys.every(key => {
            return filters[key]['function'](player, filters[key]['condition']);
          });
        });
      },
    },
    created(){
      this.$store.dispatch('getContests');
    },
    methods:{
      dateFormated(date){
        const dateFormat = new Date(date);
        return `${dateFormat.getFullYear()}-${dateFormat.getMonth() + 1}-${dateFormat.getDate()}`;
      },
      filterName(item, condition){
        return condition == undefined || condition == '' || item.name.toLowerCase().indexOf(condition.toLowerCase()) != -1;
      },
      filterStatus(item, condition){
        return condition == undefined || condition.value == '' || item.status.value == condition.value;
      },
      filterStartDate(item, condition){
        return condition == null || (new Date(condition).getTime() - new Date(item.cfg.start).getTime()) <= 0;
      },
      executeContestAction(contestId,type){
        this.$store.dispatch('actionContest',{contestId:contestId,type:type});
      },
      viewContest(contestId){
        this.$router.push('/fantasy/contest/'+contestId);
      },
      updateContest(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.$store.dispatch('getContests');
        }
      },
      getColorStatus(val){
        if (val == 'open'){
          return 'green  lighten-4';
        } else if (val == 'new'){
          return 'blue lighten-4';
        } else if (val == 'closed'){
          return 'red lighten-4';
        } else if (val == 'pending'){
          return 'brown lighten-4';
        } else if (val == 'finished'){
          return 'blue-grey lighten-4';
        }
      },
    }
  }
</script>

<style lang="sass">
.fantasy-contest__list
  .v-list-item + .v-list-item
    border-top: 1px solid rgba(0, 0, 0, 0.12)
</style>